import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

const defaultQueryFn = async ({ queryKey, meta }) => {
    const { page = 1, include = 'all', transform } = meta;
    const params = new URLSearchParams({
    //   page: page.toString(),
      include,
    });
    // console.log(params.toString());
    let { data } = await authenticatedApi.get(`/${queryKey[0]}/${queryKey[1]}?${params}`)

    try {
        data = transform(data);
    } catch(e) {
        //
    }

    return data;//data.hasOwnProperty('data') ? data.data : data;
}

export function useGetOne(queryParams) {
    const { queryKey, ...otherParams } = queryParams;
    return useQuery({
        ...queryParams,
        meta: otherParams,
        queryFn: queryParams.queryFn || defaultQueryFn,
    });
}
